import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useSetAttractionHiddenMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, isHidden: t }) => r.setAttractionHidden(e, t),
		onSuccess: (t, { areaId: n }) => {
			i.invalidateQueries({ queryKey: e.attractions(n) });
		}
	});
};
//#endregion
export { i as useSetAttractionHiddenMutation };
